import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "border border-gray-200 rounded-lg p-4 py-2 mb-4" }
const _hoisted_2 = { class: "flex flex-wrap gap-x-4 gap-y-3 items-center" }
const _hoisted_3 = ["title"]
const _hoisted_4 = { class: "text-[#52526F] text-xs font-bold truncate leading-[14px] tracking-[0.06px]" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "text-textPrimary text-md mb-1 font-bold truncate" }, "Data do plantão", -1)
const _hoisted_6 = { class: "truncate" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "hidden sm:block self-stretch w-px bg-gray-200" }, null, -1)
const _hoisted_8 = ["title"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text-textPrimary font-bold text-md mb-1 truncate" }, "Status", -1)
const _hoisted_10 = { class: "text-textPrimary text-xs mt-1 truncate leading-[14px] tracking-[0.06px]" }
const _hoisted_11 = { class: "text-negative font-bold" }
const _hoisted_12 = ["title"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "text-textPrimary font-bold text-md mb-1 truncate" }, "Médico", -1)
const _hoisted_14 = { class: "truncate" }
const _hoisted_15 = {
  key: 0,
  class: "text-textPrimary text-sm font-bold truncate block leading-[18px] tracking-[0.07px]"
}
const _hoisted_16 = ["title"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "text-textPrimary font-bold text-md mb-1 truncate" }, "Escala", -1)
const _hoisted_18 = { class: "truncate" }
const _hoisted_19 = { class: "text-textPrimary truncate block" }
const _hoisted_20 = {
  key: 0,
  class: "basis-[calc(50%-8px)] sm:basis-[90px] grow shrink-0 min-w-0 overflow-hidden flex flex-col text-sm text-start",
  title: "Progresso"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "text-textPrimary font-bold text-md mb-1 truncate" }, "Progresso", -1)
const _hoisted_22 = {
  key: 1,
  class: "text-neutralLight text-xs"
}
const _hoisted_23 = { class: "basis-full sm:basis-auto sm:ml-auto shrink-0 flex justify-end" }

import { computed } from 'vue'
import OutlinedButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import type { ApprovalInstanceDto } from '@/Network/Types/Requests/DoctorStationExceptionRequests'
import {
  Doctor,
  ExceptionStatusEnum
} from '@/Network/Types/Requests/DoctorStationExceptionRequests'
import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import { getFirstAndSecondName } from '@/utils/getFirstAndSecondName'
import StatusBadge from '@/components/designSystem/Badges/StatusBadge.vue'
import ApprovalProgressBar from './ApprovalProgressBar.vue'
import { useFeatureFlags } from '@/hooks/useFeatureFlags'


export default /*#__PURE__*/_defineComponent({
  __name: 'AuditoriumExceptionalitiesCard',
  props: {
  date: {
    type: String,
    default: ''
  },
  status: {
    type: String as () => ExceptionStatusEnum,
    required: true,
    validator: (val: ExceptionStatusEnum) => Object.values(ExceptionStatusEnum).includes(val)
  },
  doctor: {
    type: Object as () => Doctor | null,
    default: null
  },
  scale: {
    type: String,
    default: ''
  },
  unit: {
    type: String,
    default: ''
  },
  prejudice: {
    type: String,
    required: true
  },
  exceptionId: {
    type: [Number],
    required: true
  },
  approvalInstance: {
    type: Object as () => ApprovalInstanceDto | null,
    default: null
  }
},
  emits: ["details"],
  setup(__props) {

const props = __props;

const { flags } = useFeatureFlags()





const formattedDate = computed(() => {
  if (props.date) {
    try {
      return format(new Date(props.date), 'dd/MM/yyyy', { locale: ptBR })
    } catch (e) {
      console.error('Error formatting date:', e)
      return props.date
    }
  }
  return 'Data não informada'
})

const formattedPrejudice = computed(() => {
  if (props.prejudice) {
    const numericValue = parseFloat(props.prejudice)
    if (!isNaN(numericValue)) {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(numericValue)
    }
  }
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(0)
})

const doctorName = computed(() => {
  if (props.doctor && props.doctor.name) {
    return getFirstAndSecondName(props.doctor.name)
  }
  return 'Médico não informado'
})

const doctorCrm = computed(() => {
  if (props.doctor && props.doctor.crm && props.doctor.crm.number && props.doctor.crm.uf) {
    return `${props.doctor.crm.number}-${props.doctor.crm.uf}`
  }
  return ''
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "basis-[calc(50%-8px)] sm:basis-[140px] shrink-0 min-w-0 flex flex-col text-sm text-start",
        title: `#${__props.exceptionId} - ${formattedDate.value}`
      }, [
        _createElementVNode("span", _hoisted_4, "#" + _toDisplayString(__props.exceptionId), 1),
        _hoisted_5,
        _createElementVNode("span", _hoisted_6, _toDisplayString(formattedDate.value), 1)
      ], 8, _hoisted_3),
      _hoisted_7,
      _createElementVNode("div", {
        class: "basis-[calc(50%-8px)] sm:basis-[130px] grow shrink-0 min-w-0 flex flex-col text-sm text-start",
        title: `${__props.status} - Prejuízo previsto: ${formattedPrejudice.value}`
      }, [
        _hoisted_9,
        _createVNode(StatusBadge, { status: __props.status }, null, 8, ["status"]),
        _createElementVNode("span", _hoisted_10, [
          _createTextVNode("Prejuízo previsto: "),
          _createElementVNode("strong", _hoisted_11, _toDisplayString(formattedPrejudice.value), 1)
        ])
      ], 8, _hoisted_8),
      _createElementVNode("div", {
        class: "basis-[calc(50%-8px)] sm:basis-[130px] grow shrink-0 min-w-0 flex flex-col text-sm text-start",
        title: doctorName.value + (doctorCrm.value ? ` - ${doctorCrm.value}` : '')
      }, [
        _hoisted_13,
        _createElementVNode("span", _hoisted_14, _toDisplayString(doctorName.value), 1),
        (doctorCrm.value)
          ? (_openBlock(), _createElementBlock("small", _hoisted_15, _toDisplayString(doctorCrm.value), 1))
          : _createCommentVNode("", true)
      ], 8, _hoisted_12),
      _createElementVNode("div", {
        class: "basis-[calc(50%-8px)] sm:basis-[130px] grow shrink-0 min-w-0 flex flex-col text-sm text-start",
        title: `${__props.scale || 'Não informada'} - ${__props.unit || 'Não informada'}`
      }, [
        _hoisted_17,
        _createElementVNode("span", _hoisted_18, _toDisplayString(__props.scale || 'Não informada'), 1),
        _createElementVNode("small", _hoisted_19, _toDisplayString(__props.unit || 'Não informada'), 1)
      ], 8, _hoisted_16),
      (_unref(flags).enabledApprovalEngine)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _hoisted_21,
            (props.approvalInstance)
              ? (_openBlock(), _createBlock(ApprovalProgressBar, {
                  key: 0,
                  "approval-instance": props.approvalInstance
                }, null, 8, ["approval-instance"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_22, "-"))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_23, [
        _createVNode(OutlinedButton, {
          text: "Ver detalhes",
          width: "130px",
          height: "32px",
          "data-testid": "exception-card-details-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('details', props.exceptionId)))
        })
      ])
    ])
  ]))
}
}

})